// extracted by mini-css-extract-plugin
module.exports = {"title":"gwaIUlx5","withHeadline":"cWt85Bdq","content":"yYeO9Df2","footer":"__2RZF2z0t"};